import React from "react";

import { IconProps } from "../../types/common";

const FlagIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#63696F",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M13.9 5.5l-.24-1.2a1 1 0 00-.98-.8H5.5a1 1 0 00-1 1v15a1 1 0 001 1 1 1 0 001-1v-6h5.6l.24 1.2c.09.47.5.8.98.8h5.18a1 1 0 001-1v-8a1 1 0 00-1-1h-4.6z"
    />
  </svg>
);

export default FlagIcon;
